import { Card, Text } from "@clipboard-health/ui-components";
import { Stack, useTheme } from "@mui/material";

interface BasePerksSectionProps {
  headerText: React.ReactNode;
  icon: React.ReactNode;
  perks: React.ReactNode[];
  matchesWorkerTier: boolean;
}

export function BasePerksSection(props: BasePerksSectionProps) {
  const { icon, headerText, perks, matchesWorkerTier } = props;
  const theme = useTheme();

  return (
    <Card
      sx={{
        border: `1px solid ${
          matchesWorkerTier ? theme.palette.primary.main : theme.palette.secondary.main
        }`,
        borderRadius: 4,
        ...(matchesWorkerTier && { backgroundColor: theme.palette.primary.main }),
      }}
    >
      {matchesWorkerTier && (
        <Text
          semibold
          variant="body2"
          sx={{
            color: theme.palette.primary.contrastText,
            padding: 1,
            paddingLeft: 4,
          }}
        >
          Your membership
        </Text>
      )}
      <Stack
        direction="column"
        alignItems="left"
        gap={7}
        sx={{ padding: 5, paddingBottom: 6, backgroundColor: theme.palette.common.white }}
      >
        <Stack direction="row" alignItems="top" gap={4}>
          {icon}
          {headerText}
        </Stack>
        {perks}
      </Stack>
    </Card>
  );
}
